import React from 'react';
/**
 * Small amber "Co" chip that marks a classroom or context where the current
 * teacher is a co-docent (not the owner).
 *
 * Replaces 5 inline duplicates documented in audit B/F-DUP-2 (TeacherSidebarV2
 * + ClassroomSwitcher). Click-outside duplication is handled separately via
 * the adopted useClickOutside hook (Wave 6.2.4).
 */
export function CoBadge() {
  return <span className="text-[9px] font-black uppercase tracking-wider px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded flex-shrink-0" title="Je bent co-docent in deze klas" aria-label="Mede-docent klas" data-id="element-7964">
      Co
    </span>;
}